import hasUserRole from "../utilities/userRole.functions";
import UserRoles from "../utilities/userRoles";

const useUserRole = (userRole: string | string[]) => ({
    isVendorAdmin: hasUserRole(userRole, UserRoles.VENDOR_ADMIN),
  });
  
  export default useUserRole;